import { CapeMark } from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-gold/15 bg-ink2">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-10 lg:px-16">
        <div className="flex flex-col items-center gap-6">
          <CapeMark size={44} />
          <p
            data-testid="footer-wordmark"
            className="text-stroke-gold text-center font-display text-5xl tracking-tight sm:text-7xl lg:text-8xl"
          >
            HILMAY&rsquo;S KABAS
          </p>
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-6 border-t border-gold/10 pt-8 sm:flex-row">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted2">
            Ethiopia · Eritrea · The Horn of Africa
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted2">
            The Film — The Kaba, 2026
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted2">
            © 2026 HILMAY&rsquo;S KABAS
          </p>
        </div>
      </div>
    </footer>
  );
}
